export class leadSubmissionApi {

    private props: any;

    private handleLeadSubmission: any;

    constructor(local: any, handleLeadSubmission: (this: void) => any) {
        this.props = local;
        this.handleLeadSubmission = handleLeadSubmission;
    }

    async submitLead(bookAppointment = false) {
        var requestModel;

        requestModel = {
            "MovingFromInput": this.props.values.movingFromAddrComponent.MovingFromInput,
            "MovingFromAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
            "MovingFromCity": this.props.values.movingFromAddrComponent.MovingFromCity,
            "MovingFromState": this.props.values.movingFromAddrComponent.MovingFromState,
            "MovingFromZip": this.props.values.movingFromAddrComponent.MovingFromZip,
            "MovingFromCountryCode": this.props.values.movingFromAddrComponent.MovingFromCountryCode,
            "MovingFromClientValidated": "true",
            "MovingToInput": this.props.values.movingToAddrComponent.MovingToInput,
            "MovingToAddress": this.props.values.movingToAddrComponent.MovingToAddress,
            "MovingToCity": this.props.values.movingToAddrComponent.MovingToCity,
            "MovingToState": this.props.values.movingToAddrComponent.MovingToState,
            "MovingToZip": this.props.values.movingToAddrComponent.MovingToZip,
            "MovingToCountryCode": this.props.values.movingToAddrComponent.MovingToCountryCode,
            "MovingToClientValidated": "true",
            "MoveDate": this.props.values.movingDateString,
            "home-type": "house",
            "home-size": this.getHomeSizeforAPI(),
            "DwellingType": this.getHomeSizeforAPI(),
            "Name": this.props.values.contactName,
            "Email": this.props.values.contactEmail,
            "Phone": this.props.values.contactPhone,
            "HasVehicle": this.props.values.movingVehicle == "yes" ? "true" : "false",
            "WidgetSpecificRefCode": this.props.values.referralCode,
            "RefferalCode": this.props.values.referralCode,
            "DeviceType": (<HTMLInputElement>document.getElementById("DeviceType")).value,
            "PrevPageUrlReferrer": this.props.values.prevPageUrlReferral,
            "VendorName": this.props.values.vendorName,
            "VendorParms": this.props.values.vendorParms,
            "VendorId": this.props.values.vendorId,
            "__RequestVerificationToken": this.props.values.verificationToken,
            "quote-range": "Medium"
        };

        if (bookAppointment) {
            requestModel = {
                "MovingFromInput": this.props.values.movingFromAddrComponent.MovingFromInput,
                "MovingFromAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                "MovingFromCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                "MovingFromState": this.props.values.movingFromAddrComponent.MovingFromState,
                "MovingFromZip": this.props.values.movingFromAddrComponent.MovingFromZip,
                "MovingFromCountryCode": this.props.values.movingFromAddrComponent.MovingFromCountryCode,
                "MovingFromClientValidated": "true",
                "MovingToInput": this.props.values.movingToAddrComponent.MovingToInput,
                "MovingToAddress": this.props.values.movingToAddrComponent.MovingToAddress,
                "MovingToCity": this.props.values.movingToAddrComponent.MovingToCity,
                "MovingToState": this.props.values.movingToAddrComponent.MovingToState,
                "MovingToZip": this.props.values.movingToAddrComponent.MovingToZip,
                "MovingToCountryCode": this.props.values.movingToAddrComponent.MovingToCountryCode,
                "MovingToClientValidated": "true",
                "MoveDate": this.props.values.movingDateString,
                "home-type": "house",
                "home-size": this.getHomeSizeforAPI(),
                "DwellingType": this.getHomeSizeforAPI(),
                "Name": this.props.values.contactName,
                "Email": this.props.values.contactEmail,
                "Phone": this.props.values.contactPhone,
                "HasVehicle": this.props.values.movingVehicle === "yes" ? "true" : "false",
                "AgentCode": this.props.values.agentCode,
                "CalendarAppointmentDate": this.props.values.appointmentDateString,
                "CalendarAppointmentTime": this.props.values.appointmentTimeString.split(" ")[0],
                "CalendarAppointmentTimeOfDay": this.props.values.appointmentTimeString.split(" ")[1],
                "CalendarDuration": "1 hour",
                "AMCSalesPersonPartyID" : this.props.values.salesPersonID,
                "CalendarSalesPersonID" : this.props.values.salesPersonID,
                "SalesPerson" : this.props.values.salesPersonName,
                "CalendarUserName" : this.props.values.calendarUserName,
                "CalendarURI" : this.props.values.calendarURL, 
                "CalendarURL" : this.props.values.calendarURL,
                "IsCAS" : this.props.values.isCAS,               
                "AllocationId": this.props.values.agentAllocationId,
                "WidgetSpecificRefCode": this.props.values.referralCode,
                "RefferalCode": this.props.values.referralCode,
                "DeviceType": (<HTMLInputElement>document.getElementById("DeviceType")).value,
                "PrevPageUrlReferrer": this.props.values.prevPageUrlReferral,
                "VendorName": this.props.values.vendorName,
                "VendorParms": this.props.values.vendorParms,
                "VendorId": this.props.values.vendorId,
                "__RequestVerificationToken": this.props.values.verificationToken,
                "quote-range": "Medium"
            };
        }


        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams(requestModel)
        };

        //Call Instaquote API
        let apiSuccess = false;
        await fetch('/json/default-quote/request-estimate', requestOptions)
            .then(response => {
                if (!response.ok) {
                    throw new Error('error => Error while Submitting Lead')
                }
                return response.json();
            })
            .then((data) => {
                if (bookAppointment) {
                    this.handleLeadSubmission(data);
                }
                apiSuccess = true;
            },
                (error) => {
                    console.log(error);
                    if (bookAppointment) {
                        this.handleLeadSubmission(error);
                    }
                    apiSuccess = false;
                })
            .catch(error => {
                console.log(error);
            });

        return apiSuccess;
    }



    getHomeSizeforAPI() {
        switch (this.props.values.houseSize) {
            case "small":
                return "H1";

            case "medium":
                return "H2";

            case "large":
                return "H4";

            default:
                return "H2"
        }
    }
}